import { RequestState, createInitialRequest } from "../../../../framework/state/requestState";
import { ApiResponse, OrderLicensesVm } from "../../../../api";
import {
  ProductInformationActions,
  ProductInformationActionTypes
} from "../actions/productInformationActions";
import { handleRequestActions } from "../../../../framework/state/genericAsyncRequest";
import { orderSagas } from "../../orders/sagas/orderSagas";
import { handleFileDownloadResponse } from "../../../../utilities/fileDownload";
import produce from "immer";
import { AppState } from "../../../../setup/appRootReducer";
import { productInformationSagas } from "../sagas/productInformationSagas";

interface Requests {
  downloadOrderItemFiles: RequestState<ApiResponse<Blob>>;
  getOrderLicenses: RequestState<OrderLicensesVm>;
  downloadOrderLicenseFiles: RequestState<ApiResponse<Blob>>;
}

export interface ProductInformationSearchCriteria {
  serialNumber?: string | null;
  serialNumberTo?: string | null;
  isSearchRange?: boolean;
}

export interface ProductInformationViewState {
  requests: Requests;
  productInformationSearchCriteria?: ProductInformationSearchCriteria;
  orderLicensesVm: OrderLicensesVm | undefined;
}

const defaultState: ProductInformationViewState = {
  requests: {
    downloadOrderItemFiles: createInitialRequest(),
    getOrderLicenses: createInitialRequest(),
    downloadOrderLicenseFiles: createInitialRequest()
  },
  productInformationSearchCriteria: undefined,
  orderLicensesVm: undefined
};

export function productInformationViewReducer(
  state: ProductInformationViewState = defaultState,
  action: ProductInformationActions
): ProductInformationViewState {
  state = handleRequestActions(state, "requests", action, [
    {
      actionTypes: orderSagas.downloadOrderItemFiles.actionTypes,
      key: "downloadOrderItemFiles"
    },
    {
      actionTypes: productInformationSagas.getOrderLicenseFiles.actionTypes,
      key: "getOrderLicenses"
    },
    {
      actionTypes: productInformationSagas.downloadLicenseFiles.actionTypes,
      key: "downloadOrderLicenseFiles"
    }
  ]);

  if (orderSagas.downloadOrderItemFiles.isCompletedAction(action)) {
    handleFileDownloadResponse(action.payload.raw, `test-certificates.pdf`);
  } else if (productInformationSagas.getOrderLicenseFiles.isCompletedAction(action)) {
    state = produce(state, (draft) => {
      draft.orderLicensesVm = action.payload;
    });
  } else if (productInformationSagas.getOrderLicenseFiles.isRequestAction(action)) {
    state = produce(state, (draft) => {
      draft.orderLicensesVm = undefined;
    });
  } else if (productInformationSagas.downloadLicenseFiles.isCompletedAction(action)) {
    handleFileDownloadResponse(action.payload.raw, `license.zip`);
  }

  switch (action.type) {
    case ProductInformationActionTypes.SetProductInformationSearchCriteria:
      state = produce(state, (draft) => {
        draft.productInformationSearchCriteria = action.productInformationSearchCriteria;
      });
      break;
  }
  return state;
}

export const getProductInformationSearchCriteria = (
  state: AppState
): ProductInformationSearchCriteria | undefined =>
  state.deliveries.productInformationView.productInformationSearchCriteria;

export const getOrderLicensesVm = (state: AppState): OrderLicensesVm | undefined =>
  state.deliveries.productInformationView.orderLicensesVm;

export const getGetOrderLicensesRequest = (state: AppState): RequestState<OrderLicensesVm> =>
  state.deliveries.productInformationView.requests.getOrderLicenses;

export const getDownloadOrderItemFilesRequest = (
  state: AppState
): RequestState<ApiResponse<Blob>> =>
  state.deliveries.productInformationView.requests.downloadOrderItemFiles;
